const CirclePlusIcon = () => (
    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 5.5V11.5M6 8.5H12M16.5 8.5C16.5 12.6421 13.1421 16 9 16C4.85786 16 1.5 12.6421 1.5 8.5C1.5 4.35786 4.85786 1 9 1C13.1421 1 16.5 4.35786 16.5 8.5Z" stroke="#98A2B3" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

)

export default CirclePlusIcon
